import { Navigate, Outlet } from "react-router-dom";


const PersistLogin2 = (props) => {

  return <>{props.id_ruolo ==3 ? <Navigate to="/" /> : <Outlet/>}</>;
};

export default PersistLogin2;
